function _typeof(obj) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj);
}
function _regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
    _regeneratorRuntime = function _regeneratorRuntime() { return exports; };
    var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; }
    try {
        define({}, "");
    }
    catch (err) {
        define = function define(obj, key, value) { return obj[key] = value; };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; }
    function tryCatch(fn, obj, arg) { try {
        return { type: "normal", arg: fn.call(obj, arg) };
    }
    catch (err) {
        return { type: "throw", arg: err };
    } }
    exports.wrap = wrap;
    var ContinueSentinel = {};
    function Generator() { }
    function GeneratorFunction() { }
    function GeneratorFunctionPrototype() { }
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function () { return this; });
    var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); }
    function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) {
        var result = record.arg, value = result.value;
        return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); });
    } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); }
    function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state)
        throw new Error("Generator is already running"); if ("completed" === state) {
        if ("throw" === method)
            throw arg;
        return doneResult();
    } for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
            var delegateResult = maybeInvokeDelegate(delegate, context);
            if (delegateResult) {
                if (delegateResult === ContinueSentinel)
                    continue;
                return delegateResult;
            }
        }
        if ("next" === context.method)
            context.sent = context._sent = context.arg;
        else if ("throw" === context.method) {
            if ("suspendedStart" === state)
                throw state = "completed", context.arg;
            context.dispatchException(context.arg);
        }
        else
            "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
            if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel)
                continue;
            return { value: record.arg, done: context.done };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
    } }; }
    function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method)
        return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type)
        return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); }
    function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); }
    function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; }
    function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); }
    function values(iterable) { if (iterable) {
        var iteratorMethod = iterable[iteratorSymbol];
        if (iteratorMethod)
            return iteratorMethod.call(iterable);
        if ("function" == typeof iterable.next)
            return iterable;
        if (!isNaN(iterable.length)) {
            var i = -1, next = function next() { for (; ++i < iterable.length;)
                if (hasOwn.call(iterable, i))
                    return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; };
            return next.next = next;
        }
    } return { next: doneResult }; }
    function doneResult() { return { value: undefined, done: !0 }; }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object)
        keys.push(key); return keys.reverse(), function next() { for (; keys.length;) {
        var key = keys.pop();
        if (key in object)
            return next.value = key, next.done = !1, next;
    } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset)
            for (var name in this)
                "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type)
            throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done)
            throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var entry = this.tryEntries[i], record = entry.completion;
            if ("root" === entry.tryLoc)
                return handle("end");
            if (entry.tryLoc <= this.prev) {
                var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc");
                if (hasCatch && hasFinally) {
                    if (this.prev < entry.catchLoc)
                        return handle(entry.catchLoc, !0);
                    if (this.prev < entry.finallyLoc)
                        return handle(entry.finallyLoc);
                }
                else if (hasCatch) {
                    if (this.prev < entry.catchLoc)
                        return handle(entry.catchLoc, !0);
                }
                else {
                    if (!hasFinally)
                        throw new Error("try statement without catch or finally");
                    if (this.prev < entry.finallyLoc)
                        return handle(entry.finallyLoc);
                }
            }
        } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var entry = this.tryEntries[i];
            if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                var finallyEntry = entry;
                break;
            }
        } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type)
            throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var entry = this.tryEntries[i];
            if (entry.finallyLoc === finallyLoc)
                return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
        } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) {
            var entry = this.tryEntries[i];
            if (entry.tryLoc === tryLoc) {
                var record = entry.completion;
                if ("throw" === record.type) {
                    var thrown = record.arg;
                    resetTryEntry(entry);
                }
                return thrown;
            }
        } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try {
    var info = gen[key](arg);
    var value = info.value;
}
catch (error) {
    reject(error);
    return;
} if (info.done) {
    resolve(value);
}
else {
    Promise.resolve(value).then(_next, _throw);
} }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
} }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
        descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
} }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps)
    _defineProperties(Constructor.prototype, protoProps); if (staticProps)
    _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
} subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass)
    _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) {
    var NewTarget = _getPrototypeOf(this).constructor;
    result = Reflect.construct(Super, arguments, NewTarget);
}
else {
    result = Super.apply(this, arguments);
} return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
}
else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
} return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
} return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct)
    return false; if (Reflect.construct.sham)
    return false; if (typeof Proxy === "function")
    return true; try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () { }));
    return true;
}
catch (e) {
    return false;
} }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
}
else {
    obj[key] = value;
} return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null)
    return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object")
        return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
} return (hint === "string" ? String : Number)(input); }
import React, { Component } from 'react';
import './styles.scss';
import Menu from './menu';
import { Redirect } from 'react-router-dom';
import { http } from '../../Lib/Http/httpClient';
import { routes } from '../../router/routes';
import { getCurrentUser } from '../AuthUser/actions';
import { getAvailableRoutes } from '../Routes/actions';
import { connect } from 'react-redux';
import Loader from '../Loader';
import CommonHelper from '../../helpers/CommonHelper';
import StringHelper from '../../helpers/StringHelper';
import { EnumReportTypes } from '../../constants/EnumReportTypes';
import { IoIosMenu } from 'react-icons/io';
var Template = /*#__PURE__*/ function (_Component) {
    _inherits(Template, _Component);
    var _super = _createSuper(Template);
    function Template(props) {
        var _this;
        _classCallCheck(this, Template);
        _this = _super.call(this, props);
        _defineProperty(_assertThisInitialized(_this), "setPageTitle", function () {
            var urlParams = _this.props.match.url.split('/');
            var isAlgorithms = urlParams.includes('algorithms');
            var isReports = urlParams.includes('reports');
            if (isAlgorithms) {
                _this.algorithmPageTitleFactory(urlParams);
                return;
            }
            if (isReports) {
                _this.reportPageTitleFactory(urlParams);
                return;
            }
            _this.commonPageTitleFactory(urlParams);
        });
        _defineProperty(_assertThisInitialized(_this), "algorithmPageTitleFactory", function (urlParams) {
            var firstLetterToUpperCase = StringHelper.firstLetterToUpperCase;
            var setPageTitle = CommonHelper.setPageTitle;
            var lastUrlParam = urlParams[urlParams.length - 1];
            switch (lastUrlParam) {
                case 'edit':
                case 'create':
                    var pageTitle = "".concat(firstLetterToUpperCase(lastUrlParam), " ").concat(firstLetterToUpperCase(urlParams[2]));
                    setPageTitle(pageTitle);
                    break;
                default:
                    if (Number(lastUrlParam)) {
                        setPageTitle("".concat(firstLetterToUpperCase(urlParams[2]), " Info"));
                        return;
                    }
                    setPageTitle(firstLetterToUpperCase(lastUrlParam));
            }
        });
        _defineProperty(_assertThisInitialized(_this), "reportPageTitleFactory", function (urlParams) {
            var firstLetterToUpperCase = StringHelper.firstLetterToUpperCase;
            var setPageTitle = CommonHelper.setPageTitle;
            var lastUrlParam = urlParams[urlParams.length - 1];
            var reportType = EnumReportTypes[Number(urlParams[2])];
            switch (lastUrlParam) {
                case 'templates':
                case 'create':
                    var pageTitle = "".concat(firstLetterToUpperCase(lastUrlParam), " ").concat(firstLetterToUpperCase(reportType));
                    setPageTitle(pageTitle);
                    break;
                default:
                    var beforeLastUrlParams = urlParams[urlParams.length - 2];
                    if (beforeLastUrlParams === 'edit') {
                        var _pageTitle = "".concat(firstLetterToUpperCase(beforeLastUrlParams), " ").concat(firstLetterToUpperCase(reportType));
                        setPageTitle(_pageTitle);
                        return;
                    }
                    var reportsListTitle = "".concat(firstLetterToUpperCase(urlParams[1]), " ").concat(reportType);
                    setPageTitle(reportsListTitle);
            }
        });
        _defineProperty(_assertThisInitialized(_this), "commonPageTitleFactory", function (urlParams) {
            var firstLetterToUpperCase = StringHelper.firstLetterToUpperCase;
            var setPageTitle = CommonHelper.setPageTitle;
            var lastUrlParam = urlParams[urlParams.length - 1];
            var singular = _this.singularNameFactory(urlParams[1]);
            switch (lastUrlParam) {
                case 'edit':
                case 'create':
                    var pageTitle = "".concat(firstLetterToUpperCase(lastUrlParam), " ").concat(firstLetterToUpperCase(singular));
                    setPageTitle(pageTitle);
                    break;
                default:
                    if (Number(lastUrlParam)) {
                        setPageTitle("".concat(firstLetterToUpperCase(singular), " Info"));
                        return;
                    }
                    setPageTitle(firstLetterToUpperCase(lastUrlParam));
            }
        });
        _defineProperty(_assertThisInitialized(_this), "singularNameFactory", function (name) {
            switch (name) {
                case 'processes':
                    return name.slice(0, -2);
                case 'balanceCurrency':
                    return name;
                default:
                    return name.slice(0, -1);
            }
        });
        _defineProperty(_assertThisInitialized(_this), "closeOpenMenu", /*#__PURE__*/ _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee() {
            return _regeneratorRuntime().wrap(function _callee$(_context) {
                while (1)
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _this.setState({
                                isMenuOpened: !_this.state.isMenuOpened
                            });
                        case 2:
                            localStorage.setItem(_this.keyLocalStorageShowMenu, JSON.stringify(_this.state.isMenuOpened));
                        case 3:
                        case "end":
                            return _context.stop();
                    }
            }, _callee);
        })));
        _this.state = {
            isLoading: true,
            authUser: {},
            isMenuOpened: true
        };
        _this.keyLocalStorageShowMenu = 'showMenu';
        return _this;
    }
    _createClass(Template, [{
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                this.setPageTitle();
            }
        }, {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this2 = this;
                this.setPageTitle();
                this.props.getCurrentUser().then(function (response) {
                    _this2.props.getAvailableRoutes(response.role.id).then(function () {
                        _this2.setState({
                            isLoading: false,
                            authUser: _this2.props.authUser
                        });
                    });
                });
                var showMenu = localStorage.getItem(this.keyLocalStorageShowMenu);
                if (showMenu === null) {
                    localStorage.setItem(this.keyLocalStorageShowMenu, JSON.stringify(this.state.isMenuOpened));
                    return;
                }
                this.setState({
                    isMenuOpened: JSON.parse(showMenu)
                });
            }
        }, {
            key: "render",
            value: function render() {
                if (http.token === null) {
                    return /*#__PURE__*/ React.createElement(Redirect, {
                        to: routes.LOGIN
                    });
                }
                if (this.state.isLoading)
                    return /*#__PURE__*/ React.createElement(Loader, null);
                return /*#__PURE__*/ React.createElement("div", {
                    className: "wrapper"
                }, /*#__PURE__*/ React.createElement("nav", {
                    className: 'main-header navbar navbar-expand  navbar-white navbar-light d-flex align-items-center justify-between menuClose',
                    style: this.state.isMenuOpened === false ? {
                        'marginLeft': '65px',
                        transition: 'all 0.5 ease'
                    } : {}
                }, /*#__PURE__*/ React.createElement("div", {
                    className: "sidebar-close-btn",
                    onClick: this.closeOpenMenu
                }, /*#__PURE__*/ React.createElement(IoIosMenu, null)), /*#__PURE__*/ React.createElement("ul", {
                    className: "navbar-nav ml-auto"
                }, /*#__PURE__*/ React.createElement("li", {
                    className: "nav-item dropdown user-menu"
                }, this.state.authUser.name))), /*#__PURE__*/ React.createElement(Menu, {
                    match: this.props.match,
                    authUser: this.state.authUser,
                    isMenuOpened: this.state.isMenuOpened,
                    closeOpenMenu: this.closeOpenMenu
                }), /*#__PURE__*/ React.createElement("div", {
                    className: 'content-wrapper menuClose',
                    style: this.state.isMenuOpened === false ? {
                        'marginLeft': '65px',
                        transition: 'all 0.5 ease'
                    } : {}
                }, /*#__PURE__*/ React.createElement("div", {
                    className: "content-header"
                }, /*#__PURE__*/ React.createElement("div", {
                    className: "container-fluid"
                })), /*#__PURE__*/ React.createElement("div", {
                    className: "content"
                }, /*#__PURE__*/ React.createElement("div", {
                    className: "container-fluid"
                }, this.props.children))));
            }
        }]);
    return Template;
}(Component);
var mapStateToProps = function mapStateToProps(state) {
    return {
        authUser: state.authUser.authUser
    };
};
var mapDispatchToProps = {
    getCurrentUser: getCurrentUser,
    getAvailableRoutes: getAvailableRoutes
};
export default connect(mapStateToProps, mapDispatchToProps)(Template);
